import React, { useState } from "react";
import Header from "./components/header/Header";
import Sidebar from "./components/sidebar/Sidebar";
import { AppIcons } from "../data/appIcons";
import { Outlet, useLocation } from "react-router-dom";
import BredcomTitle from "./components/bredcomTitle/BredcomTitle";
import Image from "../components/image/Image";
import AddCandidates from "./components/common/AddCandidate";
// import AuthorizationWrap from '../app/authorizationWrap/AuthorizationWrap'

const Layout = (props) => {
    
    const location = useLocation();
    // let routhPath = location.pathname.replace('/', '');
    let segments = location.pathname.split('/');
    if (segments.length > 1) {
        // routhPath = segments[1];
    }
    // const renderComponent = props.componentRoutes.filter((x) => x.id.toLowerCase() === routhPath.toLowerCase());

    const [openCloseSidebar, setOpenCloseSidebar] = useState(false);

    const toggleSidebar = () => {
        setOpenCloseSidebar(!openCloseSidebar);
    };

    return (
        <div className="main-page-layout">
            <div
                className={`middle-page-section${openCloseSidebar ? " collapse-sidebar" : ""
                    }`}>
                <Sidebar componentRoutes={props.componentRoutes} />
                <div className="center-content-part">
                    {/* <AuthorizationWrap authorizeRoleType={renderComponent ? renderComponent[0]?.roleTypes : ''}> */}
                    <div className="header">
                        <div className="sidebar-collapse-btn" onClick={toggleSidebar}>
                            <Image
                                imagePath={AppIcons.barsIcon}
                                imgCustomClassName="open-bar"
                                altText="Menu Icon"
                            />
                        </div>
                        <Header />
                    </div>
                    <div className="content-desc-section">
                        <BredcomTitle
                        // pageTitle={breadCrumbs ? breadCrumbs[0].title : ""}
                        />
                        <div className="center-container">
                            <Outlet />
                        </div>
                    </div>

                    {/* </AuthorizationWrap> */}
                </div>
            </div>
            <div className="candidate-model-sec-main">
                <AddCandidates />
            </div>
        </div>
    );
};
export default Layout;
